
Greenmile.Geocoding = Greenmile.Geocoding || {};

Greenmile.Geocoding.Google = function() {
    return function () {

        this.geocoder = new google.maps.Geocoder();
        this.geocode = function (addresToGeocode, geocodeResultCallback, geocodeErrorCallback) {

            if (addresToGeocode) {

                this.geocoder.geocode({
                    'address': addresToGeocode
                }, function (results, status) {

                    if (status === google.maps.GeocoderStatus.OK) {

                        if (geocodeResultCallback) {
                            geocodeResultCallback(results);
                        }

                    } else {

                        if (geocodeErrorCallback) {
                            geocodeErrorCallback(status);
                        }

                    }

                });

            } else {
                return "no address found";
            }

        };

    };
}();